<template>
  <div>
    <!-- Contact form -->
    <Dialog
      v-if="!customerFormDialog"
      :visible.sync="contactFormDialog"
      :style="{ width: '900px', overflowY: 'auto' }"
      header="Contact details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="firstName">First Name*</label>
          <InputText
            id="firstName"
            v-model.trim="contact.firstName"
            required="false"
            autofocus
            :class="{ 'p-invalid': submitted && !contact.firstName }"
            :disabled="disabledArr.includes('firstName')"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="submitted && !contact.firstName"
            >First Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="lastName">Surname*</label>
          <InputText
            id="lastName"
            v-model.trim="contact.lastName"
            required="false"
            autofocus
            :class="{ 'p-invalid': submitted && !contact.lastName }"
            :disabled="disabledArr.includes('lastName')"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="submitted && !contact.lastName"
            >Last Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="jobFunction">Job Function*</label>
          <Dropdown
            id="jobFunction"
            :showClear="true"
            v-model="contact.jobFunction"
            :options="jobFunctions"
            optionLabel="jobFuncName"
            datakey="id"
            placeholder="Select Job Function"
            autofocus
            :disabled="disabledArr.includes('jobFunction')"
            :class="{ 'p-invalid': submitted && !contact.jobFunction }"
          />
          <small class="p-invalid" v-if="submitted && !contact.jobFunction"
            >Job Function is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col p-col-8">
          <label for="customer">Select Customer*</label>
          <div class="p-inputgroup">
            <InputText
              class="clearer"
              placeholder="Click button to search for customer"
              :disabled="true"
              v-model="customerName"
              :class="{ 'p-invalid': submitted && !contact.customer }"
            >
            </InputText>
            <Button
              icon="pi pi-search"
              class="p-button-warning"
              id="customer"
              @click="custSearchDialog = true"
              autofocus
              :disabled="disabledArr.includes('Customer')"
            />
          </div>
          <small class="p-invalid" v-if="submitted && !contact.customer"
            >Customer is required.</small
          >
        </div>
        <div class="p-field p-col p-col-4">
          <label for="contactJobTitle">Job Title (optional)</label>
          <InputText
            autofocus
            id="contactJobTitle"
            placeholder="Write a Job Title"
            :disabled="disabledArr.includes('contactJobTitle')"
            v-model="contact.contactJobTitle"
          >
          </InputText>
          <!-- <Dropdown
            id="jobTitle"
            v-model="contact.jobTitle"
            :options="jobTitles"
            optionLabel="jobTitleDesc"
            placeholder="Select Job Title"
            :showClear="true"
            autofocus
            :disabled="disabledArr.includes('jobTitle')"
            :class="{ 'p-invalid': submitted && !contact.jobTitle }"
          />
          <small
            class="p-invalid"
            v-if="submitted && !contact.jobTitle"
            >Job title is required.</small
          > -->
        </div>
      </div>
      <div class="p-formgrid p-grid" :key="reloadContactAddresses">
        <div class="p-field p-col">
          <label for="address1">House*</label>
          <InputText
            id="address1"
            v-model.trim="contact.address1"
            required="false"
            autofocus
            :disabled="disabledArr.includes('address1')"
            :class="{ 'p-invalid': submitted && !contact.address1 }"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="submitted && !contact.address1"
            >House is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address2">Street*</label>
          <InputText
            id="address2"
            v-model.trim="contact.address2"
            required="false"
            autofocus
            :disabled="disabledArr.includes('address2')"
            :class="{ 'p-invalid': submitted && !contact.address2 }"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="submitted && !contact.address2"
            >Street is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address3">Sub Area*</label>
          <InputText
            id="address3"
            v-model.trim="contact.address3"
            required="false"
            autofocus
            :disabled="disabledArr.includes('address3')"
            :class="{ 'p-invalid': submitted && !contact.address3 }"
            style="text-transform: uppercase;"
          />
          <small class="p-invalid" v-if="submitted && !contact.address3"
            >Sub Area is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address4">City/Town*</label>
          <CustomDropDown
            :key="reloadCustomDropdown"
            :allOptions="citiesTowns"
            :disabled="false"
            optionLabel="cityTownName"
            dataKey="id"
            :forceSelection="true"
            :showDropDownOnStart="true"
            :currentValue="cityTown1"
            placeholder="Select City/Town"
            style="width: 100%"
            @selected="setSelection1"
            :inputClass="{ 'p-invalid': submitted && !contact.cityTown }"
            :useUpperCase="true"
          />
          <small class="p-invalid" v-if="submitted && !contact.cityTown"
            >City/Town is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="postCode">Post Code</label>
          <InputText
            id="postCode"
            v-model.trim="contact.postCode"
            required="false"
            autofocus
            :disabled="disabledArr.includes('postCode')"
            style="text-transform: uppercase;"
          />
        </div>
        <!-- <div class="p-field p-col">
          <label for="country">Country</label>
          <InputText
            id="country"
            v-model.trim="contact.country"
            required="false"
            autofocus
            :disabled="disabledArr.includes('country')"
          />
        </div> -->
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="phoneNo">Phone No*</label>
          <InputText
            id="phoneNo"
            v-model.trim="contact.phoneNo"
            required="false"
            autofocus
            :disabled="disabledArr.includes('phoneNo')"
            :class="{ 'p-invalid': submitted && !contact.phoneNo }"
          />
          <small class="p-invalid" v-if="submitted && !contact.phoneNo"
            >Phone No is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="mobile">Mobile</label>
          <InputText
            id="mobile"
            v-model.trim="contact.mobile"
            required="false"
            autofocus
            :disabled="disabledArr.includes('mobile')"
          />
        </div>
        <div class="p-field p-col">
          <label for="email">Email*</label>
          <InputText
            id="email"
            v-model.trim="contact.email"
            required="false"
            autofocus
            :disabled="disabledArr.includes('email')"
            :class="{ 'p-invalid': submitted && !contact.email }"
          />
          <small class="p-invalid" v-if="submitted && !contact.email"
            >Email is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="notes">Notes</label>
          <InputText
            id="notes"
            v-model.trim="contact.notes"
            :disabled="disabledArr.includes('notes')"
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="canEmail">can Email?</label>
          <InputSwitch
            v-model="contact.canEmail"
            autofocus
            :disabled="disabledArr.includes('canEmail')"
          />
        </div>
        <div class="p-field p-col">
          <label for="canCall">can Call?</label>
          <InputSwitch
            v-model="contact.canCall"
            autofocus
            :disabled="disabledArr.includes('canCall')"
          />
        </div>
        <div class="p-field p-col">
          <label for="canMail">can Mail?</label>
          <InputSwitch
            v-model="contact.canMail"
            autofocus
            :disabled="disabledArr.includes('canMail')"
          />
        </div>
        <div class="p-field p-col">
          <label for="keyContact">Key Contact?</label>
          <InputSwitch
            v-model="contact.keyContact"
            autofocus
            :disabled="disabledArr.includes('keyContact')"
          />
        </div>
        <div class="p-field p-col">
          <label for="active">Active?</label>
          <InputSwitch
            v-model="contact.active"
            autofocus
            :disabled="disabledArr.includes('active')"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="hideDialog"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="saveContact"
        />
      </template>
    </Dialog>

    <!-- Customer form -->
    <Dialog
      v-else
      :visible.sync="customerFormDialog"
      :style="{ width: '700px', overflowY: 'auto' }"
      header="Customer Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="custName">Customer Name *</label>
          <InputText
            id="custName"
            v-model.trim="customer.custName"
            required="true"
            :class="{ 'p-invalid': customerSubmitted && !customer.custName }"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.custName"
            >Customer Name is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address1">House</label>
          <InputText
            id="address1"
            v-model.trim="customer.address1"
            :class="{ 'p-invalid': customerSubmitted && !customer.address1 }"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address1"
            >Address1 is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address2">Street</label>
          <InputText
            id="address2"
            v-model.trim="customer.address2"
            :class="{ 'p-invalid': customerSubmitted && !customer.address2 }"
            required="false"
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address2"
            >Address2 is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="address3">Sub Area</label>
          <InputText
            id="address3"
            v-model.trim="customer.address3"
            :class="{ 'p-invalid': customerSubmitted && !customer.address3 }"
            required="false"
            autofocus
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.address3"
            >Address3 is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="address4">City/Town</label>
          <CustomDropDown
            :allOptions="citiesTowns"
            :disabled="false"
            optionLabel="cityTownName"
            dataKey="id"
            :forceSelection="true"
            :showDropDownOnStart="true"
            :currentValue="cityTown"
            placeholder="Select City/Town"
            style="width: 100%"
            @selected="setSelection"
            :inputClass="{
              'p-invalid': customerSubmitted && !customer.cityTown
            }"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.cityTown"
            >City/Town is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="postCode">Post Code</label>
          <InputText
            id="postCode"
            v-model.trim="postCode"
            required="false"
            :class="{ 'p-invalid': customerSubmitted && !customer.postCode }"
            autofocus
            @blur="checkForDuplicate"
            style="text-transform: uppercase;"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.postCode"
            >Post Code is required.</small
          >
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col" v-if="duplicateChecking">
          <div class="errorMsg" style="background-color: dodgerblue;">
            <span class="errorSpan">
              Checking for duplicate customers...
            </span>
          </div>
        </div>
        <div
          class="p-field p-col"
          v-if="!duplicateChecking && duplicates.length"
        >
          <div class="errorMsg">
            <span class="errorSpan pr-5">
              Possible duplicate customers: {{ duplicates.length }}
            </span>
            <span
              class="errorSpan errorPointer pr-3"
              @click="displayDuplicateMessage = true"
            >
              View duplicates
            </span>
            <span
              class="errorSpan errorPointer"
              @click="checkForDuplicate()"
              v-if="
                lastEnteredName !== customer.custName ||
                  lastEnteredAddress1 !== customer.address1 ||
                  lastEnteredAddress2 !== customer.address2 ||
                  lastEnteredAddress3 !== customer.address3 ||
                  lastEnteredCityTown !==
                    (customer.cityTown && customer.cityTown.id) ||
                  lastEnteredPostCode !== customer.postCode
              "
            >
              Check again
            </span>
          </div>
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="region">Region</label>
          <InputText
            v-if="customer.region"
            id="region"
            v-model.trim="customer.region.regionName"
            :disabled="true"
            required="false"
          />
          <InputText v-else id="region" :disabled="true" required="false" />
        </div>
        <div class="p-field p-col">
          <label for="salesExec">Branch</label>
          <InputText
            id="branch"
            v-model.trim="branch.branchName"
            :disabled="true"
            required="false"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="salesExec">Sales Exec</label>
          <InputText
            id="salesExec"
            v-model.trim="salesExec.salesExecName"
            :disabled="true"
            required="false"
            autofocus
          />
        </div>
        <div class="p-field p-col">
          <label for="customerType">Customer Type</label>
          <Dropdown
            id="customerType"
            v-model="customerType"
            :options="customertypes"
            optionLabel="typeName"
            placeholder="Select Customer Type"
            :class="{
              'p-invalid': customerSubmitted && !customer.customerType
            }"
            :showClear="true"
          />
          <small
            class="p-invalid"
            v-if="customerSubmitted && !customer.customerType"
            >Customer Type is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="phoneNo">Phone No</label>
          <InputText
            id="phoneNo"
            v-model.trim="customer.phoneNo"
            :class="{ 'p-invalid': customerSubmitted && !customer.phoneNo }"
            required="false"
          />
          <small class="p-invalid" v-if="customerSubmitted && !customer.phoneNo"
            >Phone number is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="mobile">Email</label>
          <InputText
            id="mobile"
            v-model.trim="customer.email"
            required="false"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="mainNotes">Notes</label>
          <InputText
            id="mainNotes"
            v-model.trim="customer.mainNotes"
            required="false"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="hideAndOpenCustomer"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="saveCustomer"
        />
      </template>
    </Dialog>

    <!-- Customer duplicate message -->
    <Dialog header="Header" :visible.sync="customerDuplicateMessage">
      <template #header>
        <h3>Duplicate error</h3>
      </template>

      The following Customer seems to be a duplicate of some customers. Please
      confirm if you wish to still save this customer?

      <template #footer>
        <Button
          @click="customerDuplicateMessage = false"
          label="No"
          icon="pi pi-times"
          class="p-button-text"
        />
        <Button
          @click="sendDuplicateCustomer()"
          label="Yes"
          icon="pi pi-check"
          autofocus
        />
      </template>
    </Dialog>

    <CustomerSearchDialog
      :key="loadCustomersAgain"
      :custSearchDialog="custSearchDialog"
      :preSelectedCustomer="preSelectedCustomer"
      :disabledStep="2"
      @close="custSearchDialog = false"
      @select="updateCustomer"
      @selectCustomer="selectCustomerForm"
    />

    <duplicateTable
      v-if="displayDuplicateMessage"
      :duplicateDialog="displayDuplicateMessage"
      :dataId="'customerId'"
      :name="'Customer'"
      :namePlural="'Customers'"
      :list="duplicates"
      :disabledArr="['buttons']"
      @close="displayDuplicateMessage = false"
      @selected-customer="setCustomerSelection"
    />
  </div>
</template>

<script>
import CustomerService from "@/service/CustomerService";

import CustomerSearchDialog from "../customer/CustomerSearchDialog";
import duplicateTable from "../customer/duplicateDialog";

import {
  contactRequest,
  customerLessDataRequest,
  customerConf
} from "../sendRequest";

export default {
  name: "contactForm",
  components: {
    CustomerSearchDialog,
    duplicateTable
  },
  props: ["contactForm", "disabledArr", "contactToEdit", "reload"],
  data: () => ({
    customerService: new CustomerService(),
    customerName: "",
    custSearchDialog: false,
    contact: {
      canEmail: true,
      canCall: true,
      canMail: true,
      active: true
    },
    submitted: false,
    customerFormDialog: false,
    duplicateCustCode: null,
    customerType: {},
    customertypes: [],
    customerSubmitted: false,
    customerDuplicateMessage: false,
    loadCustomersAgain1: 0,
    postCode: "",
    branch: {},
    salesExec: {},
    customer: {},
    sendingRequest: false,
    jobFunctions: [],
    // jobTitles: [],
    citiesTowns: [],
    cityTown: {},
    cityTown1: {},
    reloadCustomDropdown1: 0,
    reloadContactAddresses1: 0,
    preSelectedCustomer: {},

    duplicates: [],
    duplicateChecking: false,
    lastEnteredName: "",
    lastEnteredPostCode: "",
    lastEnteredAddress1: "",
    lastEnteredAddress2: "",
    lastEnteredAddress3: "",
    lastEnteredCityTown: "",
    displayDuplicateMessage: false
  }),
  computed: {
    reloadCustomDropdown: {
      set(val) {
        this.reloadCustomDropdown1++;
      },
      get() {
        return "reloadCustomDropdown" + this.reloadCustomDropdown1.toString();
      }
    },
    loadCustomersAgain: {
      set() {
        this.loadCustomersAgain1++;
      },
      get() {
        return "loadCustomersAgain-" + this.loadCustomersAgain1.toString();
      }
    },
    contactFormDialog: {
      set(val) {
        if (!val) {
          this.hideDialog();
        }
      },
      get() {
        return this.contactForm ? true : false;
      }
    },
    reloadContactAddresses: {
      set() {
        this.reloadContactAddresses1++;
      },
      get() {
        return (
          "reloadContactAddresses-" + this.reloadContactAddresses1.toString()
        );
      }
    }
  },
  created() {
    this.setupComponent();

    // this.getAllActiveJobTitles()
    this.getAllActiveCitiesTowns();
    this.getAllJobFunctions();
    this.getAllActiveCustomerTypes();
  },
  watch: {
    reload(val) {
      this.setupComponent();
    },
    postCode(val) {
      this.customer.postCode = val;

      this.customerService
        .getCustomerRegion(val)
        .then(res => {
          if (res[0] && res[0].id) {
            this.customer.region = {
              id: parseInt(res[0].regionCode),
              regionName: res[0].regionName
            };
            if (res[0].salesExec) {
              this.customer.salesExec = res[0].salesExec;
              this.salesExec = res[0].salesExec;
            }
            if (res[0].mbpBranch) {
              this.customer.mbpBranch = res[0].mbpBranch;
              this.branch = res[0].mbpBranch;
            }
          } else {
            throw new Error("Nothing found");
          }
        })
        .catch(err => {
          this.customer.region = {};
          this.branch = {};
          this.customer.mbpBranch = {};
          this.salesExec = {};
          this.customer.salesExec = {};
        });
    },
    cityTown(val) {
      val && val.id
        ? (this.customer.cityTown = val)
        : (this.customer.cityTown = null);
    },
    cityTown1(val) {
      if (val && val.id) {
        this.contact.cityTown = val;
        this.reloadCustomDropdown = this.reloadCustomDropdown1 + 1;
      } else {
        this.contact.cityTown = null;
      }
    },
    customerType(val) {
      val && val.id
        ? (this.customer.customerType = val)
        : (this.customer.customerType = null);
    }
  },
  methods: {
    setCustomerSelection(customer) {
      this.displayDuplicateMessage = false;

      this.contactFormDialog = false;
      this.customerFormDialog = false;
      this.custSearchDialog = true;
      this.loadCustomersAgain++;
      this.preSelectedCustomer = customer;
      this.customer = {};
    },
    checkForDuplicate() {
      if (
        this.customer &&
        this.customer.custName &&
          this.customer.address1 &&
          this.customer.address2 &&
          this.customer.address3 &&
          this.customer.cityTown &&
          this.customer.cityTown.id &&
          this.customer.postCode &&
        (this.lastEnteredName !== this.customer.custName ||
          this.lastEnteredAddress1 !== this.customer.address1 ||
          this.lastEnteredAddress2 !== this.customer.address2 ||
          this.lastEnteredAddress3 !== this.customer.address3 ||
          this.lastEnteredCityTown !== this.customer.cityTown.id ||
          this.lastEnteredPostCode !== this.customer.postCode)
      ) {
        //

        this.lastEnteredName = this.customer.custName;
        this.lastEnteredAddress1 = this.customer.address1;
        this.lastEnteredAddress2 = this.customer.address2;
        this.lastEnteredAddress3 = this.customer.address3;
        this.lastEnteredCityTown = this.customer.cityTown.id;
        this.lastEnteredPostCode = this.customer.postCode;

        this.duplicateChecking = true;
        this.customerService
          .getDupCustomers({
            custName: this.customer.custName,
            address1: this.customer.address1,
            address2: this.customer.address2,
            address3: this.customer.address3,
            cityTown: this.customer.cityTown.id,
            postCode: this.customer.postCode,
            address4: ""
          })
          .then(data => {
            this.duplicateChecking = false;
            //
          })
          .catch(error => {
            //
            this.duplicateChecking = false;
            this.duplicates = [];

            if (error && error.response && error.response.status === 409) {
              this.duplicates = error.response.data;
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: "Error while checking for duplicate enquiries.",
                life: 5000
              });
            }
          });
      }
    },
    getAllJobFunctions() {
      this.customerService
        .getAllJobFunctions()
        .then(data => {
          this.jobFunctions = data;
          this.handleJobFunction();
        })
        .catch(err => {
          if (err.response.status !== 200)
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting job titles",
            //   life: 5000,
            // })
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content: 'Some data was not loaded from "jobfunctions"'
            });
        });
    },
    // getAllActiveJobTitles() {
    //   this.customerService
    //     .getAllActiveJobTitles()
    //     .then((data) => {
    //       this.jobTitles = data
    //     })
    //     .catch(err => {
    //

    //       if (err.response.status !== 200) {
    //         // this.$toast.add({
    //         //   severity: "error",
    //         //   summary: "Error",
    //         //   detail: "Error while getting job titles",
    //         //   life: 5000,
    //         // })
    //         this.$store.dispatch('addErrorMessage', {
    //           severity: 'error',
    //           content: 'Some data was not loaded from "activeJobTitles"'
    //         })
    //       }
    //     })
    // },
    getAllActiveCitiesTowns() {
      this.customerService
        .getAllActiveCitiesTowns()
        .then(data => (this.citiesTowns = data))
        .catch(error => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "citiesTowns"'
          });
        });
    },
    getAllActiveCustomerTypes() {
      this.customerService
        .getAllActiveCustomerTypes()
        .then(data => (this.customertypes = data))
        .catch(e => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting customer types",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeCustomerTypes"'
          });
        });
    },
    setupComponent() {
      this.customerName = "";
      this.custSearchDialog = false;
      this.contact = {
        canEmail: true,
        canCall: true,
        canMail: true,
        active: true
      };
      this.submitted = false;
      this.customerFormDialog = false;
      this.duplicateCustCode = null;
      this.customerType = {};
      this.customerSubmitted = false;
      this.customerDuplicateMessage = false;
      this.loadCustomersAgain1 = 0;
      this.postCode = "";
      this.branch = {};
      this.salesExec = {};
      this.customer = {};
      this.cityTown1 = {};
      this.sendingRequest = false;
      // this.jobFunctions = []
      // this.jobTitles = []

      let a = Object.keys(this.contactToEdit);

      if (a.length) {
        this.contact = { ...this.contactToEdit };
        //

        if (this.contactToEdit.customerId) {
          this.customerService
            .getCustomerInfo(this.contactToEdit.customerId)
            .then(data => {
              this.contact.customer = data;
              this.customerName = data.custName;

              if (!this.contactToEdit.address1)
                this.contact.address1 = data.address1;
              if (!this.contactToEdit.address2)
                this.contact.address2 = data.address2;
              if (!this.contactToEdit.address3)
                this.contact.address3 = data.address3;
              if (!this.contactToEdit.address4)
                this.contact.address4 = data.address4;
              if (!this.contactToEdit.cityTown) this.cityTown1 = data.cityTown;
              if (!this.contactToEdit.postCode)
                this.contact.postCode = data.postCode;
            })
            .catch(err => {
              // this.$toast.add({
              //   severity: "error",
              //   summary: "Error",
              //   detail: "Error while geting customer info",
              //   life: 5000,
              // })
              this.$store.dispatch("addErrorMessage", {
                severity: "error",
                content:
                  'Some data was not loaded from "customerInfo/{customerId}"'
              });
            });
        }

        if (
          this.contactToEdit.contactName &&
          !(this.contactToEdit.firstName && this.contactToEdit.lastName)
        ) {
          this.contact.firstName =
            this.contactToEdit.contactName.split(" ")[0] || "";
          this.contact.lastName =
            this.contactToEdit.contactName.split(" ")[1] || "";
        }
        if (this.contactToEdit.customer) {
          this.customerName = this.contactToEdit.customer.custName;

          if (!this.contactToEdit.address1)
            this.contact.address1 = this.contactToEdit.customer.address1;
          if (!this.contactToEdit.address2)
            this.contact.address2 = this.contactToEdit.customer.address2;
          if (!this.contactToEdit.address3)
            this.contact.address3 = this.contactToEdit.customer.address3;
          if (!this.contactToEdit.address4)
            this.contact.address4 = this.contactToEdit.customer.address4;
          if (!this.contactToEdit.cityTown)
            this.cityTown1 = this.contactToEdit.customer.cityTown;
          if (!this.contactToEdit.postCode)
            this.contact.postCode = this.contactToEdit.customer.postCode;
        }
        if (this.contactToEdit.cityTown) {
          this.cityTown1 = this.contactToEdit.cityTown;
        }

        if (
          this.contactToEdit.jobFunctionId &&
          !this.contactToEdit.jobFunction
        ) {
          if (this.jobFunctions && this.jobFunctions[0]) {
            this.contact.jobFunction = this.jobFunctions.find(
              a => a.id === this.contactToEdit.jobFunctionId
            );
          } else {
            this.contact.jobFunction = {
              jobFuncName: this.contactToEdit.jobFunctionName,
              id: this.contactToEdit.jobFunctionId
            };
          }
        }
      }
    },
    handleJobFunction() {
      if (this.jobFunctions && this.jobFunctions[0]) {
        if (
          this.contactToEdit.jobFunctionId &&
          !this.contactToEdit.jobFunction
        ) {
          this.contact.jobFunction = this.jobFunctions.find(
            a => a.id === this.contactToEdit.jobFunctionId
          );
        }
      }
    },
    hideAndOpenCustomer() {
      this.preSelectedCustomer = {};
      this.customerFormDialog = false;
      this.custSearchDialog = true;
    },
    sendDuplicateCustomer() {
      customerConf(this, "contactForm.vue");
    },
    selectCustomerForm() {
      this.customer = {};
      this.postCode = "";
      this.branch = {};
      this.salesExec = {};
      this.customerType = {};
      this.cityTown = {};
      this.customerSubmitted = false;
      this.custSearchDialog = false;
      this.customerFormDialog = true;

      setTimeout(() => {
        let a = document.getElementById("custName");
        if (a) a.focus();
      }, 100);
    },
    saveCustomer() {
      this.customerSubmitted = true;

      if (!this.duplicateCustCode) {
        this.sendingRequest = true;
        customerLessDataRequest(this, "ContactForm.vue");
      }
    },
    tabClicked() {
      // document.getElementById('lastName').focus()
    },
    updateCustomer(e) {
      if (e.customer && e.customer.customerId) {
        this.customerName = e.customer.custName;

        this.customerService
          .getCustomerInfo(e.customer.customerId)
          .then(data => {
            this.contact.customer = data;

            this.contact.address1 = data.address1;
            this.contact.address2 = data.address2;
            this.contact.address3 = data.address3;
            this.contact.address4 = data.address4;
            this.contact.postCode = data.postCode;
            this.cityTown1 = data.cityTown;
            this.reloadContactAddresses++;
          })
          .catch(error => {
            this.$store.dispatch("addErrorMessage", {
              severity: "error",
              content:
                'Some data was not loaded from "customerInfo/{customerId}"'
            });
          });
      }
    },
    saveContact() {
      this.submitted = true;
      this.sendingRequest = true;

      //
      contactRequest(this, "contactForm.vue");
    },
    hideDialog() {
      this.$emit("hide-form-dialog");
    },
    setSelection({ value, index }) {
      //
      this.cityTown = value;
      this.checkForDuplicate();
    },
    setSelection1({ value, index }) {
      //
      this.cityTown1 = value;
    }
  }
};
</script>

<style></style>
